import utils from '@/utils.js';

function b64EncodeUnicode(str) {
    // Encode in base64 with proper handling of UTF-8 characters
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}

function uuid4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function check_modified_fields(store) {
    let allow = true;
    let notify_text = "Les champs suivants ne seront pas enregistrés si vous continuez" +
        "<ul style='list-style:disc;margin-left:10px;'>";
    for (const key in store.state.edited_fields) {
        const f = store.state.edited_fields[key];
        if ([null, ""].indexOf(f.value) < 0) {
            allow = false;
            notify_text += "<li>" + f.verbose_name + "</li>";
            if (f.el) {
                utils.highlight_element(f.el, 2);
                f.el.focus();
            }
        }
    }

    notify_text += "</ul>";
    return {
        allow: allow,
        notify_text: notify_text
    };
}

// Nombre de caractères maximum d'une réponse quand la plateforme ne le précise
// pas (même valeur que le défaut du modèle Platform côté backend).
const DEFAULT_NBR_CHAR_MAX = 5000;

function char_count(text) {
    return (text || "").length;
}

function nbr_char_max(platform) {
    if (platform && platform.nbr_char_max) {
        return platform.nbr_char_max;
    }
    return DEFAULT_NBR_CHAR_MAX;
}

function is_over_limit(text, max) {
    // La limite est un maximum autorisé : on ne bloque qu'au-delà.
    return char_count(text) > max;
}

export default {
    deep_copy(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    b64_encode: b64EncodeUnicode,
    uuid4: uuid4,
    check_modified_fields: check_modified_fields,
    char_count: char_count,
    nbr_char_max: nbr_char_max,
    is_over_limit: is_over_limit,
    DEFAULT_NBR_CHAR_MAX: DEFAULT_NBR_CHAR_MAX
};